import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CTA, Eyebrow } from "@/components/ui-kit";
import { PageHero } from "@/components/PageHero";
import { IMAGES } from "@/lib/content";

const MODULES = [
  { n: "01", title: "Foundations", desc: "Install the Builder identity and clarify the life you’re building." },
  { n: "02", title: "Character & Discipline", desc: "Build the daily habits that make everything else possible." },
  { n: "03", title: "Purpose & Direction", desc: "Find clarity on what matters and where you’re headed." },
  { n: "04", title: "Leadership & Relationships", desc: "Lead yourself well, then lead and serve others." },
  { n: "05", title: "Stewardship", desc: "Manage time, money, and resources with wisdom." },
  { n: "06", title: "Legacy & Impact", desc: "Build something meaningful that outlives you." },
];

export default function System() {
  return (
    <div data-testid="system-page">
      <PageHero
        eyebrow="The Course"
        title="The System"
        subtitle="The Shift gives you the mindset. The System gives you the method — a guided path to apply the Builder Framework to every area of your life."
        testId="system-hero"
      />

      {/* MODULES */}
      <section className="bg-white text-black py-28 lg:py-36">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
          <div className="max-w-2xl">
            <Eyebrow className="!text-[#B8952E]">What’s Inside</Eyebrow>
            <h2 className="font-display text-4xl lg:text-5xl mt-6 tracking-tight">Six Modules. One Foundation.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {MODULES.map((m, i) => (
              <Reveal key={m.n} delay={i * 60}>
                <div className="border border-[#e5e5e5] p-9 h-full hover:border-[#D4AF37] transition-colors duration-300">
                  <span className="font-display text-[#B8952E] text-3xl">{m.n}</span>
                  <h3 className="font-display text-2xl mt-4">{m.title}</h3>
                  <p className="font-body text-sm text-black/55 mt-3 leading-relaxed">{m.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* WHO IT'S FOR + CTA */}
      <section
        className="relative bg-cover bg-center py-28 lg:py-40"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.86),rgba(0,0,0,0.92)), url(${IMAGES.mountains})` }}
      >
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Reveal><Eyebrow>Ready When You Are</Eyebrow></Reveal>
          <Reveal delay={100}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-7 leading-tight tracking-tight">
              Reading changes how you think.<br />
              <span className="text-[#D4AF37] italic">Building changes your life.</span>
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <div className="mt-8 flex flex-col items-center gap-3 text-white/70 font-body">
              {["Start with the book", "Then join The System", "Grow inside Builders Circle"].map((s) => (
                <span key={s} className="flex items-center gap-3">
                  <Check size={17} className="text-[#D4AF37]" /> {s}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={280}>
            <div className="mt-11 flex justify-center">
              <CTA to="/book">Start With The Shift</CTA>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
